function printOrderDetails() {
        var printContents = document.getElementById("printable-order").innerHTML;
        var newWin = window.open("", "", "width=800,height=600");
        newWin.document.write("<html><head><title>Order Details</title>");
        newWin.document.write("<style>body{font-family:Arial,sans-serif;padding:20px;} table{width:100%;border-collapse:collapse;} th,td{border:1px solid #ddd;padding:8px;}</style>");
        newWin.document.write("</head><body>");
        newWin.document.write(printContents);
        newWin.document.write("</body></html>");
        newWin.document.close();
        
        // Print immediately and close the window
        newWin.print();
        newWin.close();
      }